export default {
    "yellow": 0xffec27,
    "red": 0xff004d,
    "green": 0x00e436,
    "black": 0x000000,
    "blue": 0x29adff,
    "white": 0xfff1e8,
    "purple": 0x83769c,
    "pink": 0xff77a8,
    "magenta": 0x7e2553,
    "orange": 0xffa300,
}
